import React from 'react';
import {
  SiSlack,
  SiNotion,
  SiMicrosoftteams,
  SiGoogle,
  SiGithub,
  SiYoutube,
  SiFacebook,
  SiInstagram,
  SiTiktok,
  SiZoom,
  SiX,
  SiLinkedin,
  SiReddit,
  SiNetflix,
  SiAtlassian,
} from 'react-icons/si';
import { FiGrid, FiGlobe } from 'react-icons/fi';

// Matched by substring against an app name or URL/domain — covers both
// "Slack" (app) and "app.slack.com" (URL) with one entry.
const BRAND_ICON_MATCHERS = [
  { test: /slack/i, Icon: SiSlack, color: '#4A154B' },
  { test: /notion/i, Icon: SiNotion, color: '#000000' },
  { test: /teams/i, Icon: SiMicrosoftteams, color: '#6264A7' },
  {
    test: /google|gmail|docs\.google|drive\.google/i,
    Icon: SiGoogle,
    color: '#4285F4',
  },
  { test: /github/i, Icon: SiGithub, color: '#181717' },
  { test: /youtube/i, Icon: SiYoutube, color: '#FF0000' },
  { test: /facebook/i, Icon: SiFacebook, color: '#1877F2' },
  { test: /instagram/i, Icon: SiInstagram, color: '#E4405F' },
  { test: /tiktok/i, Icon: SiTiktok, color: '#000000' },
  { test: /zoom/i, Icon: SiZoom, color: '#2D8CFF' },
  { test: /twitter|(^|\.)x\.com/i, Icon: SiX, color: '#000000' },
  { test: /linkedin/i, Icon: SiLinkedin, color: '#0A66C2' },
  { test: /reddit/i, Icon: SiReddit, color: '#FF4500' },
  { test: /netflix/i, Icon: SiNetflix, color: '#E50914' },
  { test: /atlassian|jira|confluence/i, Icon: SiAtlassian, color: '#0052CC' },
];

const resolveBrandIcon = (name, FallbackIcon) => {
  const match = BRAND_ICON_MATCHERS.find(({ test }) => test.test(name || ''));
  const Icon = match?.Icon || FallbackIcon;
  return <Icon size={14} color={match?.color || 'var(--gray-500)'} />;
};

// The real app list is dynamic, tracker-reported data (not just these brands),
// so unmatched names fall back to a generic icon rather than nothing.
export const resolveAppIcon = (name) => resolveBrandIcon(name, FiGrid);
export const resolveUrlIcon = (name) => resolveBrandIcon(name, FiGlobe);

// No "known URLs" service/data model exists yet (unlike apps, which pull from
// the desktop tracker's reported app list) — hardcoded until URL
// classification is built for real.
export const KNOWN_URL_OPTIONS = [
  'docs.google.com',
  'drive.google.com',
  'calendar.google.com',
  'app.slack.com',
  'github.com',
  'notion.so',
  'atlassian.net',
  'zoom.us',
  'youtube.com',
  'facebook.com',
  'instagram.com',
  'tiktok.com',
  'twitter.com',
  'linkedin.com',
  'reddit.com',
  'netflix.com',
];
